import {useTranslation} from "react-i18next";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    FormControlLabel,
    Grid, IconButton,
    Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TextField,
    Typography
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMore";
import * as React from "react";
import {DeleteRounded} from "@mui/icons-material";
import {PaOrder} from "../../paOrders/constants/interfaces";

interface OrderConfiguration {
    orderId?: string;
    orderDescription?: string;
    cigNumber?: string;
    cupNumber?: string;
}

interface OrderConfigurationDetailProps {
    orders: PaOrder[];
}

const OrderConfigurationDetail = ({orders}: OrderConfigurationDetailProps) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'businessAgreement.orderConfiguration'});

    return (
        <>
            {orders && orders.length > 0 &&
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreRoundedIcon/>}>
                        <Typography>{t('title')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TableContainer>
                            <Table aria-label="orders-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('cigNumber')}</TableCell>
                                        <TableCell>{t('cupNumber')}</TableCell>
                                        <TableCell>{t('orderId')}</TableCell>
                                        <TableCell>{t('orderDescription')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {orders.map((row: any, index: number) => (
                                        <TableRow key={row.id}>
                                            <TableCell>{row.cig ? row.cig : ""}</TableCell>
                                            <TableCell>{row.cup ? row.cup : ""}</TableCell>
                                            <TableCell>{row.orderId ? row.orderId : ""}</TableCell>
                                            <TableCell>{row.description ? row.description : ""}</TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>
            }
        </>
    )
}

export default OrderConfigurationDetail;